/* global axios */
import ApiClient from '../ApiClient';

class CopilotMessages extends ApiClient {
  constructor() {
    super('captain/copilot_threads', { accountScoped: true });
  }

  get(threadId) {
    return axios.get(`${this.url}/${threadId}/copilot_messages`);
  }

  create({ threadId, ...rest }) {
    return axios.post(`${this.url}/${threadId}/copilot_messages`, rest);
  }

  // 👍/👎 numa resposta do Lumos (nota: 'boa' | 'ruim').
  avaliar({ threadId, id, nota, comentario }) {
    return axios.patch(
      `${this.url}/${threadId}/copilot_messages/${id}/avaliar`,
      { nota, comentario }
    );
  }
}

export default new CopilotMessages();
